var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cache = void 0;
const logger_1 = require("./logger");
class Cache {
    constructor(
    // in ms
    // 60 minutes by default
    cacheTime = 30 * 60 * 1000) {
        this.cacheTime = cacheTime;
        this.cache = new Map();
        this.get = (path, action) => __awaiter(this, void 0, void 0, function* () {
            const log = logger_1.logger.child({ tag: `Cache ${path}` });
            const now = new Date().getTime();
            let item = this.cache.get(path);
            if (!item || (item.timestamp + this.cacheTime) < now) {
                log.debug('Refreshing');
                item = {
                    data: yield action(),
                    timestamp: now,
                };
                this.cache.set(path, item);
            }
            else {
                log.debug('Using cached result');
            }
            return item.data;
        });
    }
}
exports.Cache = Cache;
//# sourceMappingURL=cache.js.map